import React from 'react';
import {
  FormControl,
  FormHelperText,
  Select,
  MenuItem,
} from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { ErrorMessage } from 'formik';

import { ICustomSelect } from './interface';

const useStyles = makeStyles(() => {
  return createStyles({
    root: {
      display: 'flex',
      flexGrow: 1,
    },
  });
});

const CustomSelect: React.FC<ICustomSelect> = ({
  field,
  form,
  children = '',
  options,
  ...props
}: ICustomSelect) => {
  const classes = useStyles();
  const { name } = field;
  const { setFieldValue, getFieldMeta } = form;
  const { touched, error, value } = getFieldMeta(name);

  const handleChange = (
    event: React.ChangeEvent<{
      value: unknown;
    }>,
    child: React.ReactNode,
  ) => {
    props.onChange && props.onChange(event, child);
    setFieldValue(name, event.target.value, true);
  };

  return (
    <FormControl className={classes.root}>
      <Select
        {...field}
        {...props}
        onChange={handleChange}
        onBlur={undefined}
        value={value}
        error={touched && !!error}
      >
        {options?.map(({ label, value }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        )) || children}
      </Select>
      {typeof error === 'string' && touched && (
        <FormHelperText error>
          <ErrorMessage name={name} />
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default CustomSelect;
